import type { BrandTag } from 'types/brandTag';
import useHandleApi from './useHandleApi';

export default function useBrandTagMappingsApi() {
  const { handleApi, loading } = useHandleApi({ apiDomain: import.meta.env.VITE_PLATFORM_API_URL });

  const fetchTagsForBrand = async (brandId: string): Promise<BrandTag[]> => {
    const response = await handleApi({
      endpoint: `/brand/${brandId}/tags`
    });
    return (response.data as BrandTag[]) || [];
  };

  const addTagToBrand = async (brandId: string, tagId: string) =>
    handleApi({
      endpoint: `/brand/${brandId}/tags/${tagId}`,
      method: 'POST',
      data: {}
    });

  const updateAllTagsForBrand = async (brandId: string, tagIds: string[]) => {
    const response = await handleApi({
      endpoint: `/brand/${brandId}/tags`,
      method: 'POST',
      data: { tagIds }
    });
    return response.data;
  };

  const removeTagFromBrand = async (brandId: string, tagId: string) =>
    handleApi({
      endpoint: `/brand/${brandId}/tags/${tagId}`,
      method: 'DELETE'
    });

  const fetchBrandsByTagId = async (tagId: string) => {
    const response = await handleApi({
      endpoint: `/brand-tags/${tagId}/brands`
    });
    return response.data || [];
  };

  return {
    loading,
    fetchTagsForBrand,
    addTagToBrand,
    updateAllTagsForBrand,
    removeTagFromBrand,
    fetchBrandsByTagId
  };
}
